export const AGENT_VISITS_PATH = "/agent/visits";
